
export const CONVERSATION_TYPE = {
  MESSAGE: 'message',
  EVENT: 'event'
};

export const MESSAGE_TYPE = {
  TEXT: 'text',
  IMG: 'image',
  FILE: 'file',
  AUDIO: 'audio',
  VIDEO: 'video'
};

export const TAB_KEYS = {
  CHATS: 'chat',
  FAVORITES: 'fav',
  CONTACTS: 'contact',
  RECENT: 'recent'
};

export const GROUP_EVENTS = {
  ADDED: 'added',
  CREATED: 'created',
  REMOVED: 'removed',
  RENAMED: 'renamed'
};
